/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';
import moment from 'moment-timezone';
import {capitalize} from 'lodash';

import Link from './Link';
import {StoryBookIcon} from './svg';
import {createURLWithParams} from '../util';

const BlogPostCard = ({post, trackerEvent, urlParams}) => {
  const router = useRouter();
  const url = `/blog/${post.slug}`;

  const handleClick = () => {
    trackerEvent?.();
    router.push(createURLWithParams(url, urlParams));
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer py-3 px-5 border border-gray-200 rounded-lg hover:border-gray-300 transition duration-50 overflow-hidden"
    >
      <div className="hidden md:flex flex-col w-full">
        <div className="flex relative -mt-3 -mx-5 mb-5 h-36 justify-center items-center bg-gray-100">
          {post.feature_image
            ? <img src={post.feature_image} className="w-full h-full object-cover" loading="lazy" width="400" height="200" alt={post.title} />
            : <StoryBookIcon className="w-10 h-10 text-gray-400" />}
          <div className="absolute inset-0 w-full h-full bg-gray-200 opacity-10" />
        </div>
      </div>
      <div className="flex flex-col justify-between w-full">
        <Link href={url}>
          <h3 className="text-xl font-semibold mb-2">{post.title}</h3>
        </Link>
        <div className="mb-2 flex items-center space-x-2 text-sm font-medium text-gray-500">
          {(post.updated_at || post.published_at)
            && capitalize(moment(post.updated_at || post.published_at).fromNow())}
          {post.reading_time && (
          <span>
            &nbsp;&nbsp;•&nbsp;&nbsp;
            {post.reading_time}
            {' '}
            min read
          </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogPostCard;
